import { getListEInvoiceApi, getListSearchInputApi, UpdateSearchAddList, signEInvoice, cancelEInvoice, deleteEInvoice, exportExcelListEInvoiceApi, getNumberEinvoiceUpdateTaxAuthorityApi, searchByEzInvoiceIdApi, createMultiPublishEInvoiceApi } from '@/api/action-defines/e-invoice-management'
import { getSitePartner, detailSiteApi } from "@/api/action-defines/site-management.js";
import { getDetailEInvoice } from "@/api/action-defines/e-invoice-management"
import { publishEInvoice, createEInvoice, viewPdfEInvoice, previewPdfEInvoice, sendInvoieCQTApi, getInvoieStatusCQTApi, updateInvoiceStatusCQTMulApi } from "@/api/action-defines/e-invoice-management"
import { mapGetters, mapState } from 'vuex';
import {
  DxDataGrid,
  DxScrolling,
  DxPager,
  DxPaging,
  DxSelection,
  DxColumn,
  DxLoadPanel,
} from 'devextreme-vue/data-grid';
import flatPickr from 'vue-flatpickr-component';
import Paging from '../site-management/paging/Paging.vue'
import AddEInvoice from './add-e-invoice/AddEInvoice.vue';
import EInvoiceDetailDisable from './e-invoice-detail-disable'
import dayjs from 'dayjs';
import { $GET } from '@/api/gateway/gatewayMethods';
import { INPUT_TYPE } from '@/@core/data/enum/inputType';
import { INVOICE_STATUS, INVOICE_STATUS_CODE, TAX_AUTHORITY_STATUS } from '@/@core/data/enum/invoiceStatus';
import { EInvoiceActionCodes } from '@/@core/data/enum/menuCode';
import ModuleInvoice from "@/views/components/module-invoice";
import { PartnerCode } from "@/@core/data/enum/partnerCode.js";
import { INVOICE_ACTION } from "@/@core/data/enum/eInvoiceActionType.js";
import { i18n } from '@/libs/i18n';
import router from '@/router';
export default {
  name: 'EInvoice',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPager,
    DxPaging,
    DxSelection,
    DxColumn,
    DxLoadPanel,
    Paging,
    flatPickr,
    AddEInvoice,
    EInvoiceDetailDisable,
    ModuleInvoice,
  },
  data() {
    return {
      dataSource: [],
      inputSearchList: [],
      inputSearchBarStatus: [],
      statusList: [...INVOICE_STATUS],
      statusListFilter: [...INVOICE_STATUS],
      taxAuthorityStatus: [...TAX_AUTHORITY_STATUS],
      invoiceStatusCodeList: { ...INVOICE_STATUS_CODE },
      dateRange: '',
      search: {
        FormInvoice: [],
        SerialInvoice: [],
        EInvoiceNo: '',
        StartDate: null,
        EndDate: null,
        SignStatus: [],
        InvoiceStatus: [],
        TaxAuthorityCode: '',
        TaxAuthorityStatus: [],
      },
      lastSearch: {
        FormInvoice: [],
        SerialInvoice: [],
        EInvoiceNo: '',
        StartDate: null,
        EndDate: null,
        SignStatus: [],
        InvoiceStatus: [],
        TaxAuthorityCode: '',
        TaxAuthorityStatus: [],
      },
      //Pagination
      paging: {
        PageSize: 10,
        PageIndex: 1,
      },
      totalPagination: {
        TotalRecord: 0,
        TotalPage: 0,
      },
      statistics: {
        TotalDraft: 0,
        TotalOriginal: 0,
        TotalReplacement: 0,
        TotalReplaced: 0,
        TotalAdjustment: 0,
        TotalAdjusted: 0,
      },
      fakeListDropdown: [],
      filterBy: '',
      filterOptions: [
      ],
      filterList: [],
      EinvoiceDetailData: {},
      rerenderKey: false,
      selectedRows: [],
      invoiceData: {
        AfterTaxAmount: 0,
        CompanyName: '',
        CustomerTax: '',
        EInvoiceDate: '',
        EInvoiceNo: '',
        Id: '',
        ListReference: [],
        Serial: '',
        StatusEInvoice: 0,
        StatusSign: false,
        TaxAuthorityStatus: 0
      },
      isReady: false,
      showConfirmSignModal: false,
      selectedInvoiceId: null, // ID hoá đơn được chọn để ký,
      confirmUpdateMulTaxAuthorityContent: '',
      partnerInfo: {},
      colsDefault: [
        {
          caption: '',
          field: 'checkbox',
          isShow: true,
          alignment: 'center',
          cellTemplate: 'checkbox-cell',
          headerCellTemplate: 'checkbox-header',
          width: '40px',
        },
        {
          caption: this.$t('e_invoice_management_invoice_number'),
          field: 'EInvoiceNo',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'invoice-number-cell',
          width: '8%',
        },
        {
          caption: this.$t('common_serial'),
          field: 'Serial',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'serial-cell',
          width: '10%',
        },
        {
          caption: this.$t('e_invoice_management_invoice_date'),
          field: 'EInvoiceDate',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'invoice-date-cell',
          width: '10%',
        },
        {
          caption: this.$t('common_company_name'),
          field: 'CompanyName',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'company-name-cell',
          width: '15%',
        },
        {
          caption: this.$t('common_vat_code'),
          field: 'CustomerTax',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'vat-code-cell',
          width: '10%',
        },
        {
          caption: this.$t('e_invoice_management_sign_status'),
          field: 'StatusSign',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'sign-status-cell',
          width: '12%',
        },
        {
          caption: this.$t('e_invoice_management_status'),
          field: 'StatusEInvoice',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'invoice-status-cell',
          width: '11%',
        },
        {
          caption: this.$t('e_invoice_tax_authority_status'),
          field: 'TaxAuthorityStatus',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'tax_authority_status',
          width: '11%',
        },
        {
          caption: this.$t('common_reference'),
          field: 'ListReference',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'reference-cell',
          width: '14%',
        },
        {
          caption: this.$t('common_amount'),
          field: 'AfterTaxAmount',
          isShow: true,
          alignment: 'left',
          cellTemplate: 'ammount-cell',
          width: '5%',
        },
        {
          caption: this.$t('common_actions'),
          field: 'action',
          isShow: true,
          alignment: 'right',
          cellTemplate: 'actions-cell',
          width: '5%',
        },
      ],
    }
  },
  async created() {
    await this.getPartnerInfo();
    const { MINVOICE, CYBER_BILL, MISA, VNPT_V5, VIETTEL, SUN, EASY } = PartnerCode;
    if (![MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)) {
      this.colsDefault = this.colsDefault.map((x) => {
        if (x.field === 'StatusSign') x.isShow = false;
        return x;
      })
    }

    if (![MISA, VNPT_V5].includes(this.partnerInfo.PartnerCode)) {
      this.colsDefault = this.colsDefault.map((x) => {
        if (x.field === 'TaxAuthorityStatus') x.isShow = false;
        return x;
      })
    }

    if (![VIETTEL, SUN, CYBER_BILL, VNPT_V5, EASY].includes(this.partnerInfo.PartnerCode)) {
      this.statusListFilter = this.statusListFilter.filter((x) => {
        if (x.id !== 6) return x;
      })
    }


    await this.getListSearchInput();
    const params = new URLSearchParams(window.location.search);
    let ezInvoiceId = params.get('ezInvoiceId');
    if (ezInvoiceId !== null && ezInvoiceId !== undefined && ezInvoiceId !== '') {
      await this.getListEInvoiceByEzInvoiceId(ezInvoiceId);
    } else {
      await this.getListEInvoice();
    }
    await this.isActiveSite();
  },

  methods: {
    async isActiveSite() {
      this.activeSiteStatus = true;
      const QueryParameters = {
        siteId: this.$ls_CurrentSiteID,
      };

      await detailSiteApi({ QueryParameters }).then((res) => {
        if (res.IsSuccess) {
          if (res.Data.Status.toUpperCase() !== 'ACTIVE') {
            let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
            this.$toast.error(text);
            this.activeSiteStatus = false;
          }
        }
      });
    },
    isCanAddEInvoice() {
      return this.$lsAllowOperation(EInvoiceActionCodes.ADD);
    },
    isCanViewEInvoice() {
      return this.$lsAllowOperation(EInvoiceActionCodes.VIEW);
    },
    isCanCancelInvoice() {
      return this.$lsAllowOperation(EInvoiceActionCodes.CANCEL);
    },
    isCanChangeFilter() {
      return this.$lsAllowOperation(EInvoiceActionCodes.ADD_FILTER);
    },
    isCanReleaseInvoice() {
      return this.$lsAllowOperation(EInvoiceActionCodes.RELEASE) && this.EinvoiceDetailData.StatusEInvoice === this.invoiceStatusCodeList.DRAFT;
    },
    isCanAdjustEInvoice() {
      let qualifiedCondition = false;
      const { MINVOICE, CYBER_BILL, MISA } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;

      if ([MINVOICE, CYBER_BILL, MISA].includes(this.partnerInfo.PartnerCode) &&
        [ORIGINAL, ADJUSTED].includes(this.EinvoiceDetailData.StatusEInvoice)
      ) {
        qualifiedCondition = true;
      }

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        this.EinvoiceDetailData.StatusSign &&
        qualifiedCondition;
    },
    isCanIncreaseAdjustmentEInvoice() {
      const { VIETTEL, FAST, EASY, VNPT, VNPT_V5 } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;

      const partnerList = [VIETTEL, FAST, EASY, VNPT, VNPT_V5];
      const statusList = [ORIGINAL, ADJUSTED];

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        partnerList.includes(this.partnerInfo.PartnerCode) &&
        statusList.includes(this.EinvoiceDetailData.StatusEInvoice);
    },
    isCanDecreaseAdjustmentEInvoice() {
      const { VIETTEL, FAST, EASY, VNPT, VNPT_V5 } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;

      const partnerList = [VIETTEL, FAST, EASY, VNPT, VNPT_V5];
      const statusList = [ORIGINAL, ADJUSTED];

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        partnerList.includes(this.partnerInfo.PartnerCode) &&
        statusList.includes(this.EinvoiceDetailData.StatusEInvoice);
    },
    isCanAdjustEInvoiceValue() {
      const { CYBER_BILL } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;

      const partnerList = [CYBER_BILL];
      const statusList = [ORIGINAL, ADJUSTED];

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        partnerList.includes(this.partnerInfo.PartnerCode) &&
        statusList.includes(this.EinvoiceDetailData.StatusEInvoice);
    },

    exportBulkInvoice() {
      this.$refs.confirmBulkPublish.isOpen = true;
    },

    async confirmBulkPublishFunc() {
      this.$refs.confirmBulkPublish.isOpen = false;

      if (this.selectedRows.length > 30) {
        this.$toast.error(this.$t('e_invoice_max_50_bulk_publish_exceeded'));
        return;
      }

      const invoiceList = [];

      for (const id of this.selectedRows) {
        try {
          const res = await getDetailEInvoice({ BodyData: { EInvoiceId: id } });
          if (res.StatusCode === '200') {
            const einvoice = res.Data.EInvoice;
            const items = res.Data.EInvoiceDetails || [];

            // Same item transformation as AddEInvoice's handleReleaseInvoice
            const transformedItems = items.map(item => ({
              ...item,
              SubAmount: item.BeforeTaxAmount,
              ReferenceItemId: item.ItemId,
              ServiceRate: item.Charges,
              ServicesCharge: item.ChargesAmount,
              DiscountPercent: 0,
              AfterTaxAmount: item.TotalAmount,
            }));

            const eInvoiceDate = einvoice.EinvoiceDate
              ? dayjs(einvoice.EinvoiceDate).format("YYYY-MM-DDTHH:mm")
              : dayjs().format("YYYY-MM-DDTHH:mm");


            // Same bodyData shape as AddEInvoice's prepareInvoiceData
            const bodyData = {
              ...einvoice,
              EinvoiceDate: eInvoiceDate,
              FormNo: einvoice.FormNo,
              Serial: einvoice.Serial,
              CurrencyCode: 'VND',
              ExchangeRate: 0,
              SubAmount: einvoice.SubAmount || 0,
              DiscountPercent: 0,
              DiscountAmount: einvoice.DiscountAmount || 0,
              ServiceRate: einvoice.ServiceRate || 0,
              ServicesCharge: einvoice.ServicesCharge || 0,
              BeforeTaxAmount: einvoice.BeforeTaxAmount || 0,
              TaxRate: einvoice.TaxRate,
              TaxAmount: einvoice.TaxAmount || 0,
              AfterTaxAmount: einvoice.AfterTaxAmount || 0,
              StatusSign: false,
              HotelId: '0',
              EInvoiceDetails: transformedItems,
              IsGrouped: false,
            };

            invoiceList.push(bodyData);
          }
        } catch (error) {
          console.error('Error fetching invoice detail for id:', id, error);
        }
      }

      if (invoiceList.length === 0) {
        this.$toast.error(this.$t('common_error'));
        return;
      }

      try {
        const BodyData = { Invoices: invoiceList };
        const publishedCount = this.selectedRows.length;
        const res = await createMultiPublishEInvoiceApi({ BodyData });
        if (res.StatusCode === '200') {
          this.$toast.success(`${this.$t('success')}`);
          this.selectedRows = [];
          this.getListEInvoice();
        } else {
          this.$toast.error(this.$t('common_error'));
        }
      } catch (error) {
        this.$toast.error(this.$t('common_error'));
      }
    },

    isCanAdjustEInvoiceInformation() {
      const { VIETTEL, FAST, EASY, VNPT, VNPT_V5 } = PartnerCode;
      const { ORIGINAL, ADJUSTED } = INVOICE_STATUS_CODE;

      const partnerList = [VIETTEL, FAST, EASY, VNPT, VNPT_V5];
      const statusList = [ORIGINAL, ADJUSTED];

      return this.$lsAllowOperation(EInvoiceActionCodes.ADJUST) &&
        partnerList.includes(this.partnerInfo.PartnerCode) &&
        statusList.includes(this.EinvoiceDetailData.StatusEInvoice);
    },
    isCanReplaceEInvoice() {
      const acceptableInvoiceStatus = [INVOICE_STATUS_CODE.ORIGINAL, INVOICE_STATUS_CODE.REPLACEMENT];
      const { MINVOICE } = PartnerCode;
      if ([MINVOICE].includes(this.partnerInfo.PartnerCode)) {
        if (acceptableInvoiceStatus.includes(this.EinvoiceDetailData.StatusEInvoice) &&
          this.$lsAllowOperation(EInvoiceActionCodes.REPLACE) &&
          this.EinvoiceDetailData.StatusSign
        ) {
          return true;
        }
      }

      const { VIETTEL, VNPT, VNPT_V5, MISA, FAST, EASY } = PartnerCode;
      if ([VIETTEL, VNPT, VNPT_V5, MISA, FAST, EASY].includes(this.partnerInfo.PartnerCode)) {
        if (acceptableInvoiceStatus.includes(this.EinvoiceDetailData.StatusEInvoice) &&
          this.$lsAllowOperation(EInvoiceActionCodes.REPLACE)
        ) {
          return true;
        }
      }

      return false;
    },
    isCanPreviewEInvoice() {
      const { VIETTEL, MISA, FAST, EASY } = PartnerCode;
      const { DRAFT } = INVOICE_STATUS_CODE;
      if ([VIETTEL, MISA, FAST, EASY].includes(this.partnerInfo.PartnerCode)
        //&& this.$lsAllowOperation(EInvoiceActionCodes.PREVIEW)
        && [DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)) {
        return true;
      }
      return false;
    },
    isCanViewPdfEInvoice() {
      const { VIETTEL, MINVOICE, SUN, CYBER_BILL, MISA, VNPT, VNPT_V5, FAST, EASY } = PartnerCode;
      const { DRAFT } = INVOICE_STATUS_CODE;
      const partnerList = [VIETTEL, MINVOICE, SUN, CYBER_BILL, MISA, VNPT, VNPT_V5, FAST, EASY];

      if (partnerList.includes(this.partnerInfo.PartnerCode)
        && this.$lsAllowOperation(EInvoiceActionCodes.VIEW_PDF)
        && ![DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)) {
        return true;
      }
      return false;
    },
    isCanCancelEInvoice() {
      // const { CMC, MINVOICE, VNPT, SUN, VIETTEL, FAST, EASY, CYBER_BILL } = PartnerCode;
      // const { ORIGINAL, ADJUSTMENT, ADJUSTED, REPLACED, REPLACEMENT } = INVOICE_STATUS_CODE;

      // if ([VIETTEL, VNPT, FAST, EASY].includes(this.partnerInfo.PartnerCode)
      //   && this.EinvoiceDetailData.StatusEInvoice === ORIGINAL
      //   && this.$lsAllowOperation(EInvoiceActionCodes.CANCEL)
      // ) 
      // {
      //   return true;
      // }

      // if ([MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)
      //   && this.EinvoiceDetailData.StatusEInvoice === ORIGINAL
      //   && this.EinvoiceDetailData.StatusSign 
      //   && this.$lsAllowOperation(EInvoiceActionCodes.CANCEL)
      // ) 
      // {
      //   return true;
      // }

      return false;

    },
    isCanDeleteEInvoice() {
      const { MINVOICE, CYBER_BILL, VNPT, VNPT_V5, EASY } = PartnerCode;
      const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT } = INVOICE_STATUS_CODE;

      if (this.$lsAllowOperation(EInvoiceActionCodes.DELETE)) {
        if ([MINVOICE].includes(this.partnerInfo.PartnerCode)) {
          if ([ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign) {
            return true;
          }
        }

        if ([CYBER_BILL].includes(this.partnerInfo.PartnerCode)) {
          if ([ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign) {
            return true;
          }

          if ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)) {
            return true;
          }
        }

        if ([VNPT, VNPT_V5, EASY].includes(this.partnerInfo.PartnerCode)) {
          if ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)) {
            return true;
          }
        }
      }

      return false;

    },
    isCanSendSingleTaxAuthorityMul() {
      const { MISA, VNPT_V5 } = PartnerCode;
      if ([MISA, VNPT_V5].includes(this.partnerInfo.PartnerCode)) {
        return true;
      }

      return false;
    },
    isCanSendSingleTaxAuthoritySingle() {
      const { MISA, VNPT_V5 } = PartnerCode;
      if ([MISA].includes(this.partnerInfo.PartnerCode)) {
        return true;
      }

      if ([VNPT_V5].includes(this.partnerInfo.PartnerCode)
        && (this.EinvoiceDetailData.TaxAuthorityStatus === 0 || this.EinvoiceDetailData.TaxAuthorityStatus === null)) {
        return true;
      }
      return false;
    },
    async sendSingleTaxAuthority(data) {
      const BodyData = {
        ezInvoiceIds: [
          data.data.EzInvoiceId
        ],
        FormNo: data.data.FormNo,
        Serial: data.data.Serial,
        InvoiceType: data.data.InvoiceType,
        TypeEinvoice: data.data.TypeEinvoice
      }
      try {
        const response = await sendInvoieCQTApi({ BodyData });
        if (response != undefined && response.IsSuccess == true && response.StatusCode == 200) {
          this.$toast.success(this.$t('mn_action_send_single_tax_authority_success'));
          const responseStatus = await getInvoieStatusCQTApi({ BodyData });
          if (responseStatus != undefined && responseStatus.IsSuccess == true && responseStatus.StatusCode == 200) {
            this.$toast.success(this.$t('mn_action_update_tax_authority_status_success'));
            this.getListEInvoice();
          } else {
            this.$toast.error(this.$t('mn_action_update_tax_authority_status_fail'));
          }
        } else {
          this.$toast.error(this.$t('mn_action_send_single_tax_authority_fail'));
        }
      } catch (error) {
        this.$toast.error(this.$t('mn_action_send_single_tax_authority_fail'));
      }


    },
    async openReleaseInvoiceConfirm(data) {
      const BodyData = {
        EInvoiceId: data.data.Id,
      };
      this.einvoice = {};
      await getDetailEInvoice({ BodyData: BodyData })
        .then((res) => {
          if (res.StatusCode === "200") {
            this.einvoice = res.Data;
          } else {
            console.log(res.Messages);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      var requiredInputs = [];
      if (this.einvoice.EInvoice.EinvoiceDate === '' || this.einvoice.EInvoice.EinvoiceDate === null) {
        requiredInputs.push('e_invoice_detail_invoice_date');
      }

      if (this.einvoice.EInvoice.Serial === '' || this.einvoice.EInvoice.Serial === null) {
        requiredInputs.push('e_invoice_detail_invoice_serial');
      }

      if (this.einvoice.EInvoice.FormNo === '' || this.einvoice.EInvoice.FormNo === null) {
        requiredInputs.push('e_invoice_detail_invoice_form');
      }

      if ((this.einvoice.EInvoice.CustomerName === '' || this.einvoice.EInvoice.CustomerName === null) && (this.einvoice.EInvoice.CompanyName === '' || this.einvoice.EInvoice.CompanyName === null)) {
        requiredInputs.push('common_buyer');
      }

      if (this.einvoice.EInvoice.PaymentMethodCode === '' || this.einvoice.EInvoice.PaymentMethodCode === null) {
        requiredInputs.push('common_payment_method');
      }

      if (requiredInputs.length > 0) {
        let text = this.$t('add_einvoice_pls_insert_required_input') + ': ';
        requiredInputs.forEach(element => {
          text += this.$t(element) + ', ';
        });
        text = text.slice(0, -2) + '.';
        this.$toast.error(text);
        return;
      }

      if (!this.activeSiteStatus) {
        let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
        this.$toast.error(text);
        return;
      }

      if (this.einvoice.EInvoiceDetails.length <= 0) {
        let text = this.$t('add_einvoice_pls_add_service')
        this.$toast.error(text);
        return;
      }

      // let onlyExternalService = true;
      // this.einvoice.EInvoiceDetails.forEach(elm =>{
      //   if (elm.isAdded !== undefined){
      //     onlyExternalService = false;
      //   }
      // });

      // if (onlyExternalService){
      //   let text = this.$t('add_einvoice_unable_create_invoice_without_services_external_providers_pls_check_and_try_again')
      //   this.$toast.error(text);
      //   return;
      // }
      this.$refs.confirmAddEinvoice.isOpen = true;

    },
    async confirmAddEinvoiceFunc() {
      this.$refs.confirmAddEinvoice.isOpen = false;
      const BodyData = this.einvoice;
      const { VNPT, VNPT_V5, SUN, VIETTEL, MISA } = PartnerCode;
      const { CMC, MINVOICE, CYBER_BILL } = PartnerCode;

      const partnerHavePublishEInvoice = [VNPT, VNPT_V5, SUN, VIETTEL, MISA];
      const parnerHaveCreateEInvoice = [CMC, MINVOICE, CYBER_BILL];


      if (parnerHaveCreateEInvoice.includes(this.partnerInfo.PartnerCode)) {
        await createEInvoice({ BodyData }).then(res => {
          if (res.StatusCode === '200') {
            this.$toast.success(this.$t('success'));
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
          }
          this.getlistEInvoice();
        })
      } else if (partnerHavePublishEInvoice.includes(this.partnerInfo.PartnerCode)) {
        await publishEInvoice({ BodyData }).then(res => {
          if (res.StatusCode === '200') {
            this.$toast.success(this.$t('success'));
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
          }
          this.getlistEInvoice();
        })
      }

    },
    openAdjustInvoice(data, adjustActionCode) {
      this.invoiceData = data.data;

      if (!this.activeSiteStatus) {
        let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
        this.$toast.error(text);
        return;
      }
      if (adjustActionCode === INVOICE_ACTION.ADJUST_INVOICE) {
        this.$refs.adjustEInvoice.isOpen = true;
      }
      if (adjustActionCode === INVOICE_ACTION.ADJUST_INVOICE_INFORMATION) {
        this.$refs.adjustEInvoiceInformation.isOpen = true;
      }
      if (adjustActionCode === INVOICE_ACTION.ADJUST_INVOICE_VALUE) {
        this.$refs.adjustEInvoiceValue.isOpen = true;
      }
      if (adjustActionCode === INVOICE_ACTION.ADJUST_INCREASE_INVOICE) {
        this.$refs.adjustIncreaseEInvoice.isOpen = true;
      }
      if (adjustActionCode === INVOICE_ACTION.ADJUST_DECREASE_INVOICE) {
        this.$refs.adjustDecreaseEInvoice.isOpen = true;
      }
    },
    openReplaceEInvoice(data) {
      this.invoiceData = data.data;
      if (!this.activeSiteStatus) {
        let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
        this.$toast.error(text);
        return;
      }
      this.$refs.replaceEInvoice.isOpen = true;
    },
    async openViewPdfEInvoice(data) {
      if (!this.activeSiteStatus) {
        let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
        this.$toast.error(text);
        return;
      }
      const BodyDataGetDetail = {
        EInvoiceId: data.data.Id,
      };
      this.einvoice = {};

      await getDetailEInvoice({ BodyData: BodyDataGetDetail })
        .then((res) => {
          if (res.StatusCode === "200") {
            this.einvoice = res.Data;
            console.log(this.einvoice);
          } else {
            console.log(res.Messages);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      if (this.einvoice) {
        const BodyDataViewPdf = {
          InvoiceCreateStatus: this.einvoice.EInvoice.StatusEinvoice === 6 ? "Draft" : "Official",
          ezInvoiceId: this.einvoice.EInvoice.EzInvoiceId,
          ThirdPartyInvoiceNumber: this.einvoice.EInvoice.ThirdPartyInvoiceNumber,
          ThirdPartyInvoiceCode: "",
          TransactionId: this.einvoice.EInvoice.TransactionId,
          searchCode: this.einvoice.EInvoice.SearchCode,
          invtmp: 0,
          FormNo: this.einvoice.EInvoice.FormNo,
          Serial: this.einvoice.EInvoice.Serial ? this.einvoice.EInvoice.Serial : "",
          InvoiceType: 0,
          TypeEinvoice: 0
        };
        await viewPdfEInvoice({ BodyData: BodyDataViewPdf }).then(res => {
          if (res.StatusCode === '200') {
            this.$toast.success(this.$t('success'));
            if (res.Data.Type === 1) {
              const base64PDF = res.Data.InvoicePDF;
              const byteCharacters = atob(base64PDF);
              const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
              const byteArray = new Uint8Array(byteNumbers);

              const blob = new Blob([byteArray], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl);
            }

            if (res.Data.Type === 2) {
              const pdfUrl = res.Data.InvoicePDF; // link trả về từ API
              window.open(pdfUrl, '_blank');
            }
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
          }
        })
      }


    },

    async redirectInvoiceDetail(data) {
      function openEInvoiceInNewTab(ezInvoiceId) {
        const resolved = router.resolve({
          path: '/e-invoice',
          query: { ezInvoiceId }
        })
        // mở tab mới
        window.open(resolved.href, '_blank', 'noopener,noreferrer')
      }
      const ezEinvoiceId = data.data.EzInvoiceId;
      const { MINVOICE, CYBER_BILL, VIETTEL, VNPT, SUN, MISA } = PartnerCode;
      const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT } = INVOICE_STATUS_CODE;

      if ([MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)
        && ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
          || ([DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign))
        && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
      ) {
        openEInvoiceInNewTab(ezEinvoiceId);
      } else if ([VIETTEL, VNPT, SUN, MISA].includes(this.partnerInfo.PartnerCode)
        && [DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
        && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
      ) {
        openEInvoiceInNewTab(ezEinvoiceId);
      } else {
        openEInvoiceInNewTab(ezEinvoiceId);
      }
    },

    async openViewPdfRefEInvoice(data) {
      if (!this.activeSiteStatus) {
        let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
        this.$toast.error(text);
        return;
      }
      const BodyDataGetDetail = {
        EInvoiceId: data.Id,
      };
      this.einvoice = {};
      await getDetailEInvoice({ BodyData: BodyDataGetDetail })
        .then((res) => {
          if (res.StatusCode === "200") {
            this.einvoice = res.Data;
            console.log(this.einvoice);
          } else {
            console.log(res.Messages);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      if (this.einvoice) {
        const BodyDataViewPdf = {
          InvoiceCreateStatus: this.einvoice.EInvoice.StatusEinvoice === 6 ? "Draft" : "Official",
          ezInvoiceId: this.einvoice.EInvoice.EzInvoiceId,
          ThirdPartyInvoiceNumber: this.einvoice.EInvoice.ThirdPartyInvoiceNumber,
          ThirdPartyInvoiceCode: "",
          TransactionId: this.einvoice.EInvoice.TransactionId,
          searchCode: this.einvoice.EInvoice.SearchCode,
          invtmp: 0,
          FormNo: this.einvoice.EInvoice.FormNo,
          Serial: this.einvoice.EInvoice.Serial ? this.einvoice.EInvoice.Serial : "",
          InvoiceType: 0,
          TypeEinvoice: 0
        };
        await viewPdfEInvoice({ BodyData: BodyDataViewPdf }).then(res => {
          if (res.StatusCode === '200') {
            this.$toast.success(this.$t('success'));
            if (res.Data.Type === 1) {
              const base64PDF = res.Data.InvoicePDF;
              const byteCharacters = atob(base64PDF);
              const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
              const byteArray = new Uint8Array(byteNumbers);

              const blob = new Blob([byteArray], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl);
            }

            if (res.Data.Type === 2) {
              const pdfUrl = res.Data.InvoicePDF; // link trả về từ API
              window.open(pdfUrl, '_blank');
            }
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
          }
        })

      }

    },

    async openPreviewPdfEInvoice(data) {
      if (!this.activeSiteStatus) {
        let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
        this.$toast.error(text);
        return;
      }
      const BodyData = {
        EInvoiceId: data.data.Id,
      };

      await previewPdfEInvoice({ BodyData: BodyData }).then(res => {
        if (res.StatusCode === '200') {
          this.$toast.success(this.$t('success'));
          if (res.Data.Type === 1) {
            const base64PDF = res.Data.InvoicePDF;
            const byteCharacters = atob(base64PDF);
            const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl);
          }

          if (res.Data.Type === 2) {
            const pdfUrl = res.Data.InvoicePDF; // link trả về từ API
            window.open(pdfUrl, '_blank');
          }
          this.$router.push({
            name: 'invoice-management',
            query: { reload: true }
          });
        }
      })

    },
    openCancelEInvoice(data) {
      this.einvoice = {};
      this.einvoice = data.data;

      if (!this.activeSiteStatus) {
        let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
        this.$toast.error(text);
        return;
      }

      this.$refs.confirmCancel.isOpen = true;
    },
    openDeleteEInvoice(data) {
      this.einvoice = {};
      this.einvoice = data.data;
      console.log(this.einvoice);
      if (!this.activeSiteStatus) {
        let text = this.$t('add_einvoice_pls_check_connect_config_ezInvoice')
        this.$toast.error(text);
        return;
      }

      this.$refs.confirmDelete.isOpen = true;
    },
    async confirmCancel() {
      const BodyData = {
        Id: this.einvoice.Id,
        Reason: '',
      };

      await cancelEInvoice({ BodyData: BodyData })
        .then((res) => {
          if (res.StatusCode === '200') {
            this.$refs.confirmCancel.isOpen = false;
            this.$toast.success(this.$t('common_success'));
          }
        })
        .catch((error) => {
          console.log(error);
        });

      this.$refs.confirmCancel.isOpen = false;
    },
    async confirmDelete() {
      const BodyData1 = {
        EInvoiceId: this.einvoice.Id
      };
      this.einvoice = {};

      await getDetailEInvoice({ BodyData: BodyData1 })
        .then((res) => {
          if (res.StatusCode === "200") {
            this.einvoice = res.Data;
          } else {
            console.log(res.Messages);
          }
        })
        .catch((error) => {
          console.log(error);
        });
      const BodyData = {
        Id: this.einvoice.EInvoice.Id,
        Reason: '',
      };
      await deleteEInvoice({ BodyData: BodyData })
        .then((res) => {
          if (res.StatusCode === '200') {
            this.$refs.confirmDelete.isOpen = false;
            this.$toast.success(this.$t('common_success'));
            this.getListEInvoice();
          }
        })
        .catch((error) => {
          console.log(error);
        });

      this.$refs.confirmDelete.isOpen = false;
    },
    openDropdown(data) {
      //this.EinvoiceDetailData = {};
      this.EinvoiceDetailData = data.data;
    },
    async getPartnerInfo() {
      const res = await getSitePartner();
      this.partnerInfo = res.Data;
    },
    formatNumber(number) {
      return new Intl.NumberFormat('de-US').format(number);
    },

    onContentReady(e) {
      e.component.option('loadPanel.enabled', false);
    },

    // Cột "Ngày hóa đơn" hiển thị cả giờ:phút:giây. EInvoiceDate do ev24 trả về đã là GIỜ KHÁCH SẠN
    // và không qua quy đổi offset ở bất kỳ tầng nào (xem InvoiceDateConvention bên backend), nên format
    // thẳng giá trị nhận được — KHÔNG dùng .utc()/.local() của dayjs, sẽ lệch theo múi giờ máy người xem.
    getDateTimeDmy(date) {
      return dayjs(date).format('DD/MM/YYYY HH:mm:ss');
    },

    getInvoiceStatistic(statisticList) {
      if (!statisticList) return;

      statisticList.map((e) => {
        switch (e.Name) {
          case 'ORIGINAL':
            this.statistics.TotalOriginal = e.Value
            break;
          case 'REPLACEMENT':
            this.statistics.TotalReplacement = e.Value
            break;
          case 'REPLACED':
            this.statistics.TotalReplaced = e.Value
            break;
          case 'ADJUSTMENT':
            this.statistics.TotalAdjustment = e.Value
            break;
          case 'ADJUSTED':
            this.statistics.TotalAdjusted = e.Value
            break;
          case 'CANCELED':

            break;
          case 'DRAFT':
            this.statistics.TotalDraft = e.Value
            break;

          default:
            break;
        }
      })
    },

    async getListSearchInput() {
      this.IsShowSignStatus = true;
      const { MINVOICE, CYBER_BILL, MISA, VNPT_V5 } = PartnerCode;
      await getListSearchInputApi()
        .then((res) => {
          if (res.StatusCode == 200) {
            this.inputSearchBarStatus = res.Data;
            this.inputSearchList = [];

            for (let i = 0; i < res.Data.Invoice.length; i++) {
              if (res.Data.Invoice[i].FieldKey === 'SignStatus' && ![MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)) {
                continue;
              }

              if (res.Data.Invoice[i].FieldKey === 'TaxAuthorityStatus' && ![MISA, VNPT_V5].includes(this.partnerInfo.PartnerCode)) {
                continue;
              }
              this.inputSearchList.push(res.Data.Invoice[i]);
            }
            this.inputSearchList = this.inputSearchList.map(async (e) => {
              let fieldValueRes = null;

              if (e.ApiRoute && e.FieldFormatType === 'MultiSelectbox') {
                fieldValueRes = await $GET({ EndPoint: e.ApiRoute, QueryParameters: null })
              }

              const fieldValue = fieldValueRes?.Data.map((e) => {
                return {
                  value: e.Key,
                  text: e.Value,
                }
              })

              return {
                ...e,
                FieldValue: fieldValue,
              }
            })
            Promise.all(this.inputSearchList)
              .then((value) => {
                this.inputSearchList = value;
                value.forEach((k) => {
                  if (k.Status) {
                    this.filterList.push(k.Id);
                  }
                });
                this.filterOptions = value.map((k) => {
                  return {
                    value: k.Id,
                    text: k.FieldName,
                  };
                });
                return value;
              })
              .then((value) => {
                this.rerenderKey = true;

              })
          }
        })
        .catch((err) => {
          console.log(err);
        })
    },

    async getListEInvoice() {
      const self = this;
      this.inputSearchBarStatus.Invoice.forEach((elm) => {
        if (elm.Status === false) {
          if (elm.FieldFormatType === 'MultiSelectbox') {
            this.search[elm.FieldKey] = [];
          }

          if (elm.FieldFormatType === 'Textbox') {
            this.search[elm.FieldKey] = '';
          }

          if (elm.FieldFormatType === 'DateRange') {
            this.search.StartDate = null;
            this.search.EndDate = null;
          }
        } else {
          if (elm.FieldFormatType === 'MultiSelectbox') {
            if (elm.FieldKey !== 'SignStatus' && elm.FieldKey !== 'InvoiceStatus' && elm.FieldKey !== 'TaxAuthorityStatus') {
              this.search[elm.FieldKey] = this.search[elm.FieldKey].map((e) => {
                this.inputSearchList.forEach((item) => {
                  if (item.FieldKey === elm.FieldKey) {
                    e = item.FieldValue[e].text;
                  }
                })
                return e;
              });
            }
          }
        }
        return elm;
      })



      this.search.SignStatus = this.search.SignStatus.map((e) => e ? true : false);
      this.recentCreateEinvoiceDate = '';
      if (!this.dateRange) {
        this.search.StartDate = null;
        this.search.EndDate = null;
      }

      this.lastSearch.FormInvoice = this.search.FormInvoice,
        this.lastSearch.SerialInvoice = this.search.SerialInvoice,
        this.lastSearch.EInvoiceNo = this.search.EInvoiceNo,
        this.lastSearch.StartDate = this.search.StartDate,
        this.lastSearch.EndDate = this.search.EndDate,
        this.lastSearch.SignStatus = this.search.SignStatus,
        this.lastSearch.InvoiceStatus = this.search.InvoiceStatus,
        this.lastSearch.TaxAuthorityCode = this.search.TaxAuthorityCode

      const BodyData = {
        ...this.search,
        ...this.paging,
      };

      await getListEInvoiceApi({ BodyData })
        .then((res) => {
          if (res.StatusCode == 200) {
            this.recentCreateEinvoiceDate = res.Data.RecentCreateEinvoiceDate;
            const RecentCreateEinvoiceDate = new Date(this.recentCreateEinvoiceDate);
            // Lấy ngày/tháng/năm THEO GIỜ ĐỊA PHƯƠNG: RecentCreateEinvoiceDate là giờ khách sạn,
            // BE không còn cộng offset (xem InvoiceDateConvention). Dùng getUTC* ở đây sẽ trừ đi
            // múi giờ của trình duyệt và ra sai NGÀY với hóa đơn tạo trong 00:00–06:59.
            const day = RecentCreateEinvoiceDate.getDate();
            const month = RecentCreateEinvoiceDate.getMonth() + 1; // Tháng bắt đầu từ 0
            const year = RecentCreateEinvoiceDate.getFullYear();
            // Format thành chuỗi d/m/y
            const formattedDate = `${day}-${month}-${year}`;
            this.$globalData.RecentCreateEinvoiceDate = formattedDate;
            this.totalPagination.TotalRecord = res.Data.TotalRecord;
            this.totalPagination.TotalPage = Math.ceil(
              this.totalPagination.TotalRecord / this.paging.PageSize,
            );
            this.getInvoiceStatistic(res.Data.TotalCountStatusEInvoice);
            self.dataSource = res.Data.listEInvoices;
          }
        })
        .catch((err) => {
          console.log(err);
        });


    },

    async getListEInvoiceByEzInvoiceId(EzInvoiceId) {
      const self = this;
      this.inputSearchBarStatus.Invoice.forEach((elm) => {
        if (elm.Status === false) {
          if (elm.FieldFormatType === 'MultiSelectbox') {
            this.search[elm.FieldKey] = [];
          }

          if (elm.FieldFormatType === 'Textbox') {
            this.search[elm.FieldKey] = '';
          }

          if (elm.FieldFormatType === 'DateRange') {
            this.search.StartDate = null;
            this.search.EndDate = null;
          }
        } else {
          if (elm.FieldFormatType === 'MultiSelectbox') {
            if (elm.FieldKey !== 'SignStatus' && elm.FieldKey !== 'InvoiceStatus' && elm.FieldKey !== 'TaxAuthorityStatus') {
              this.search[elm.FieldKey] = this.search[elm.FieldKey].map((e) => {
                this.inputSearchList.forEach((item) => {
                  if (item.FieldKey === elm.FieldKey) {
                    e = item.FieldValue[e].text;
                  }
                })
                return e;
              });
            }
          }
        }
        return elm;
      })



      this.search.SignStatus = this.search.SignStatus.map((e) => e ? true : false);
      this.recentCreateEinvoiceDate = '';
      if (!this.dateRange) {
        this.search.StartDate = null;
        this.search.EndDate = null;
      }

      this.lastSearch.FormInvoice = this.search.FormInvoice,
        this.lastSearch.SerialInvoice = this.search.SerialInvoice,
        this.lastSearch.EInvoiceNo = this.search.EInvoiceNo,
        this.lastSearch.StartDate = this.search.StartDate,
        this.lastSearch.EndDate = this.search.EndDate,
        this.lastSearch.SignStatus = this.search.SignStatus,
        this.lastSearch.InvoiceStatus = this.search.InvoiceStatus,
        this.lastSearch.TaxAuthorityCode = this.search.TaxAuthorityCode

      const BodyData = {
        EzInvoiceId: EzInvoiceId
      };

      await searchByEzInvoiceIdApi({ BodyData })
        .then((res) => {
          if (res.StatusCode == 200) {
            this.recentCreateEinvoiceDate = res.Data.RecentCreateEinvoiceDate;
            const RecentCreateEinvoiceDate = new Date(this.recentCreateEinvoiceDate);
            // Lấy ngày/tháng/năm THEO GIỜ ĐỊA PHƯƠNG: RecentCreateEinvoiceDate là giờ khách sạn,
            // BE không còn cộng offset (xem InvoiceDateConvention). Dùng getUTC* ở đây sẽ trừ đi
            // múi giờ của trình duyệt và ra sai NGÀY với hóa đơn tạo trong 00:00–06:59.
            const day = RecentCreateEinvoiceDate.getDate();
            const month = RecentCreateEinvoiceDate.getMonth() + 1; // Tháng bắt đầu từ 0
            const year = RecentCreateEinvoiceDate.getFullYear();
            // Format thành chuỗi d/m/y
            const formattedDate = `${day}-${month}-${year}`;
            this.$globalData.RecentCreateEinvoiceDate = formattedDate;
            this.totalPagination.TotalRecord = res.Data.TotalRecord;
            this.totalPagination.TotalPage = Math.ceil(
              this.totalPagination.TotalRecord / this.paging.PageSize,
            );
            this.getInvoiceStatistic(res.Data.TotalCountStatusEInvoice);
            self.dataSource = res.Data.listEInvoices;
          }

          if (res.Data.listEInvoices.length === 0) {
            this.$toast.error(this.$t('e_invoice_not_found'));
          } else {

            const data = {
              data: res.Data.listEInvoices[0]
            };
            this.openInvoiceDetail(data);
          }


        })
        .catch((err) => {
          console.log(err);
        });


    },

    async exportExcelListEInvoice() {
      const self = this;
      const BodyData = {
        ...this.lastSearch,
        LanguageCode: this.$i18n.locale
      };
      await exportExcelListEInvoiceApi({ BodyData })
        .then((res) => {
          if (res.StatusCode == 200) {
            const binaryString = atob(res.Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }

            // Tạo blob và trigger tải xuống
            const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = "ListEinvoice.xlsx";
            link.click();

            // Clean up
            URL.revokeObjectURL(link.href);
          }
        })
        .catch((err) => {
          console.log(err);
        });

    },

    async getNumberEinvoiceUpdateTaxAuthority() {
      const self = this;
      const BodyData = {
        ...this.lastSearch
      };
      await getNumberEinvoiceUpdateTaxAuthorityApi({ BodyData })
        .then((res) => {
          if (res.StatusCode == 200) {
            this.updateMulTaxAuthorityData = [];
            this.updateMulTaxAuthorityData = res.Data.ListEinvoiceUpdateTaxAuthoritiy;
            let confirmUpdateMulTaxAuthorityContent = this.$t('confirm_update_mul_tax_authority_content');
            let number = res.Data.ListEinvoiceUpdateTaxAuthoritiy.length;
            if (number === 0) {
              this.$toast.success(this.$t('mn_action_update_tax_authority_status_no_data'));

            } else {
              this.confirmUpdateMulTaxAuthorityContent = confirmUpdateMulTaxAuthorityContent.replace('[number]', number);
              this.$refs.confirmUpdateMulTaxAuthority.isOpen = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async confirmUpdateMulTaxAuthorityFunc() {

      const map = new Map();

      this.updateMulTaxAuthorityData.forEach(item => {
        const key = `${item.FormNo}|${item.Serial}|${item.InvoiceType}|${item.TypeEinvoice}`;

        if (!map.has(key)) {
          map.set(key, {
            FormNo: item.FormNo,
            Serial: item.Serial,
            InvoiceType: item.InvoiceType,
            TypeEinvoice: item.TypeEinvoice,
            ezInvoiceIds: []
          });
        }

        if (item.ezInvoiceIds) {
          map.get(key).ezInvoiceIds.push(item.ezInvoiceIds);
        }
      });


      const BodyData = {
        InvoiceSendCQRequestList: Array.from(map.values()).filter(x => x.ezInvoiceIds.length > 0)
      };

      await updateInvoiceStatusCQTMulApi({ BodyData })
        .then((res) => {
          if (res.StatusCode == 200) {
            this.$toast.success(this.$t('mn_action_update_tax_authority_status_success'));
            this.getListEInvoice();
          }
          else {
            this.$toast.error(this.$t('mn_action_update_tax_authority_status_fail'));
          }
        })
        .catch((err) => {
          this.$toast.error(err.message || this.$t('mn_action_update_tax_authority_status_fail'));
        });
      this.$refs.confirmUpdateMulTaxAuthority.isOpen = false;
    },

    changePage(paging) {
      this.paging = paging;
      this.getListEInvoice();
    },

    searchEInvoice() {
      this.paging.PageIndex = 1;
      this.getListEInvoice();
    },

    exportingExcel() {
      this.exportExcelListEInvoice();
    },

    async addFilterClick() {
      const BodyData = {
        invoiceRequestItems: this.filterOptions.map((f) => {
          let check = false;

          if (this.filterList.includes(f.value)) {
            check = true;
          }
          return {
            InvoiceRequestItemID: f.value,
            Status: check,
          }
        })
      }
      await UpdateSearchAddList({ BodyData })
        .then((res) => {
          if (res.StatusCode == 200) {
            this.inputSearchBarStatus = res.Data;
            this.inputSearchList.map((f) => {
              if (this.filterList.includes(f.Id)) {
                f.Status = true;
              } else {
                f.Status = false;  //reset status to false when remove filter
              }
              return f;
            })
            this.$toast.success(this.$t('config_update_sucessfully'));
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.$refs.filterCheckbox.open = false;
    },

    async addFilterDefault() {
      let filterDefault = this.inputSearchBarStatus.Invoice.filter((elm) => {
        return elm.FieldKey === 'SignStatus'
          || elm.FieldKey === 'FormInvoice'
          || elm.FieldKey === ''
          || elm.FieldKey === 'InvoiceStatus'
          || elm.FieldKey === 'SerialInvoice'
          || elm.FieldKey === 'EInvoiceNo';
      })
        .map(elm => elm.Id);
      while (this.filterList.length > 0) {
        this.filterList.pop();
      }
      filterDefault.forEach((elm) => {
        this.filterList.push(elm);
      });
      const BodyData = {
        invoiceRequestItems: this.filterOptions.map((f) => {
          let check = false;

          if (this.filterList.includes(f.value)) {
            check = true;
          }
          return {
            InvoiceRequestItemID: f.value,
            Status: check,
          }
        })
      }
      await UpdateSearchAddList({ BodyData })
        .then((res) => {
          if (res.StatusCode == 200) {
            this.inputSearchBarStatus = res.Data;
            this.inputSearchList.map((f) => {
              if (this.filterList.includes(f.Id)) {
                f.Status = true;
              } else {
                f.Status = false;  //reset status to false when remove filter
              }
              return f;
            })
          }
          this.$toast.success(this.$t('config_update_sucessfully'));
        })
        .catch((err) => {
          console.log(err);
        });
      this.$refs.filterCheckbox.open = false;
    },

    cancelFilterClick() {
      this.$refs.filterCheckbox.open = false;
    },

    openAddInvoice() {
      this.$refs.addEInvoice.actionType = 'add_invoice';
      this.$refs.addEInvoice.isOpen = true;
      document.body.style.overflow = 'hidden';
    },

    openInvoiceDetail(data) {
      const { MINVOICE, CYBER_BILL, VIETTEL, VNPT, SUN, MISA, VNPT_V5, EASY } = PartnerCode;
      const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT } = INVOICE_STATUS_CODE;

      if ([MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)
        && ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
          || ([DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign))
        && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
      ) {
        this.invoiceData = data.data;
        this.$refs.changeEInvoice.isOpen = true;
      } else if ([VIETTEL, VNPT, SUN, MISA, VNPT_V5, EASY].includes(this.partnerInfo.PartnerCode)
        && [DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
        && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
      ) {
        this.invoiceData = data.data;
        this.$refs.changeEInvoice.isOpen = true;
      } else {
        this.$refs.eInvoiceDetailDisable.EinvoiceDetailData = data.data;
        this.$refs.eInvoiceDetailDisable.isOpen = true;
      }
      document.querySelector('body').style.overflow = 'hidden';
    },

    openConfirmSignModal(id) {
      this.selectedInvoiceId = id;
      this.$refs.signEinvoice.isOpen = true;
    },

    async confirmSignEinvoiceFunc() {
      const BodyData = { Id: this.selectedInvoiceId };

      try {
        const response = await signEInvoice({ BodyData });
        if (response != undefined && response.IsSuccess == true && response.StatusCode == 200) {
          this.$toast.success(this.$t('common_success_sign_einvoice'));
          this.getListEInvoice();
        } else {
          this.$toast.error(this.$t('common_fail_sign_einvoice'));
        }
      } catch (error) {
        this.$toast.error(this.$t('common_fail_sign_einvoice'));
      }
      this.$refs.signEinvoice.isOpen = false;

    },



    applyAddFilter() {

    },

    cancelAddFilter() {

    },

    applyDefaultFilterSet() {

    },

    async handleReleaseEInvoice(data) {
      document.querySelector('body').style.overflow = 'hidden';
      if (data.data.StatusEInvoice === INVOICE_STATUS_CODE.DRAFT) {
        const BodyData = {
          EInvoiceId: data.data.Id,
        };
        await getDetailEInvoice({ BodyData: BodyData })
          .then((res) => {
            if (res.StatusCode === "200") {
              console.log(res);
            } else {
              console.log(res.Messages);
            }
          })
          .catch((error) => {
            console.log(error);
          });

      }
    },

    setSearchDate() {
      console.log(this.dateRange);
      if (this.dateRange.includes('->')) {
        const dateRange = this.dateRange.split('-> ');
        if (!dateRange[0] || !dateRange[1]) return;
        this.search.StartDate = dayjs(dayjs(dateRange[0], 'DD/MM/YYYY').format('YYYY-MM-DD').trim()).format();
        this.search.EndDate = dayjs(dayjs(dateRange[1], 'DD/MM/YYYY').add(1, 'day').format('YYYY-MM-DD').trim()).format();
      } else {
        this.search.StartDate = dayjs(dayjs(this.dateRange, 'DD/MM/YYYY').format('YYYY-MM-DD').trim()).format();
        this.search.EndDate = dayjs(dayjs(this.dateRange, 'DD/MM/YYYY').add(1, 'day').format('YYYY-MM-DD').trim()).format();
      }
    },

    displayInputByType(inputType) {
      switch (inputType) {
        case 'MultiSelectbox':
          return true;
        case 'Textbox':
          return true;
        case 'DateRange':
          return true;
        default:
          return false;
      }
    },

    async filterByStatus(statusId) {
      if (statusId.toString() === this.filterBy) {
        this.filterBy = '';
      } else {
        this.filterBy = statusId.toString();
      }

      if (this.filterBy) {
        let self = this;
        this.paging.PageIndex = 1;
        this.search = {
          FormInvoice: [],
          SerialInvoice: [],
          EInvoiceNo: '',
          StartDate: null,
          EndDate: null,
          SignStatus: [],
          InvoiceStatus: [statusId],
          TaxAuthorityCode: '',
          OtherInfomation: '',
        };
        this.lastSearch = {
          FormInvoice: [],
          SerialInvoice: [],
          EInvoiceNo: '',
          StartDate: null,
          EndDate: null,
          SignStatus: [],
          InvoiceStatus: [statusId],
          TaxAuthorityCode: '',
          OtherInfomation: '',
        };
        const BodyData = {
          ...this.search,
          ...this.paging,
        };
        await getListEInvoiceApi({ BodyData })
          .then((res) => {
            if (res.StatusCode == 200) {
              this.recentCreateEinvoiceDate = res.Data.RecentCreateEinvoiceDate;
              const RecentCreateEinvoiceDate = new Date(this.recentCreateEinvoiceDate);
              // Lấy ngày/tháng/năm THEO GIỜ ĐỊA PHƯƠNG: RecentCreateEinvoiceDate là giờ khách sạn,
              // BE không còn cộng offset (xem InvoiceDateConvention). Dùng getUTC* ở đây sẽ trừ đi
              // múi giờ của trình duyệt và ra sai NGÀY với hóa đơn tạo trong 00:00–06:59.
              const day = RecentCreateEinvoiceDate.getDate();
              const month = RecentCreateEinvoiceDate.getMonth() + 1; // Tháng bắt đầu từ 0
              const year = RecentCreateEinvoiceDate.getFullYear();
              // Format thành chuỗi d/m/y
              const formattedDate = `${day}-${month}-${year}`;
              this.$globalData.RecentCreateEinvoiceDate = formattedDate;
              this.totalPagination.TotalRecord = res.Data.TotalRecord;
              this.totalPagination.TotalPage = Math.ceil(
                this.totalPagination.TotalRecord / this.paging.PageSize,
              );
              this.getInvoiceStatistic(res.Data.TotalCountStatusEInvoice);
              self.dataSource = res.Data.listEInvoices;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let self = this;
        this.paging.PageIndex = 1;
        this.search = {
          FormInvoice: [],
          SerialInvoice: [],
          EInvoiceNo: '',
          StartDate: null,
          EndDate: null,
          SignStatus: [],
          InvoiceStatus: [],
          TaxAuthorityCode: '',
          OtherInfomation: '',
        };
        const BodyData = {
          ...this.search,
          ...this.paging,
        };
        await getListEInvoiceApi({ BodyData })
          .then((res) => {
            if (res.StatusCode == 200) {
              this.recentCreateEinvoiceDate = res.Data.RecentCreateEinvoiceDate;
              const RecentCreateEinvoiceDate = new Date(this.recentCreateEinvoiceDate);
              // Lấy ngày/tháng/năm THEO GIỜ ĐỊA PHƯƠNG: RecentCreateEinvoiceDate là giờ khách sạn,
              // BE không còn cộng offset (xem InvoiceDateConvention). Dùng getUTC* ở đây sẽ trừ đi
              // múi giờ của trình duyệt và ra sai NGÀY với hóa đơn tạo trong 00:00–06:59.
              const day = RecentCreateEinvoiceDate.getDate();
              const month = RecentCreateEinvoiceDate.getMonth() + 1; // Tháng bắt đầu từ 0
              const year = RecentCreateEinvoiceDate.getFullYear();
              // Format thành chuỗi d/m/y
              const formattedDate = `${day}-${month}-${year}`;
              this.$globalData.RecentCreateEinvoiceDate = formattedDate;
              this.totalPagination.TotalRecord = res.Data.TotalRecord;
              this.totalPagination.TotalPage = Math.ceil(
                this.totalPagination.TotalRecord / this.paging.PageSize,
              );
              this.getInvoiceStatistic(res.Data.TotalCountStatusEInvoice);
              self.dataSource = res.Data.listEInvoices;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    getSignStatusUI(status) {
      if (status === false) {
        return {
          text: this.$t('common_not_signed'),
          color: 'text-warning'
        }
      }
      if (status === true) {
        return {
          text: this.$t('common_signed'),
          color: 'text-success'
        }
      }
    },

    getInvoiceStatusUI(statusId) {
      if (!this.statusList) return

      const status = this.statusList.find(s => s.id === statusId)

      if (!status) return {
        text: '',
        styles: '',
      }

      return {
        ...status,
        text: this.$t(status.text)
      }
    },

    getTaxAuthorityStatusUI(statusId) {
      if (!this.taxAuthorityStatus) return

      const status = this.taxAuthorityStatus.find(s => s.id === statusId)

      if (!status) return {
        text: '',
        styles: '',
      }

      return {
        ...status,
        text: this.$t(status.text)
      }
    },

    toggleRowSelection(rowData, checked) {
      if (checked) {
        if (!this.selectedRows.includes(rowData.Id)) {
          this.selectedRows.push(rowData.Id);
        }
      } else {
        this.selectedRows = this.selectedRows.filter(id => id !== rowData.Id);
      }
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.selectableRows.forEach(row => {
          if (!this.selectedRows.includes(row.Id)) {
            this.selectedRows.push(row.Id);
          }
        });
      } else {
        const selectableIds = this.selectableRows.map(row => row.Id);
        this.selectedRows = this.selectedRows.filter(id => !selectableIds.includes(id));
      }
    },

    isCanSignInvoice(data) {
      const { MINVOICE, CYBER_BILL } = PartnerCode;
      const { ORIGINAL, ADJUSTMENT, REPLACEMENT } = INVOICE_STATUS_CODE;
      return this.$lsAllowOperation(EInvoiceActionCodes.SIGN)
        && [MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)
        && [ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(data.StatusEInvoice);
    },
  },
  computed: {
    ...mapState({
      $ls_Sites: (state) => state.app.resources.Sites,
    }),
    ...mapGetters({
      $ls_CurrentSiteID: 'auth/currentSiteID',
      $lsAllowOperation: 'app/allowOperation',
    }),

    inputList() {
      return {
        ...INPUT_TYPE
      }
    },
    displayTableEInvoice() {
      return (
        this.dataSource.length > 0 ||
        this.$ls_Sites.length > 0
      )
    },
    configTable() {
      return this.colsDefault;
    },
    dataGrid() {
      return this.$refs['dataGridRef'].instance;
    },
    selectableRows() {
      return this.dataSource.filter(row => row.StatusEInvoice === 6);
    },
    isAllSelected() {
      return this.selectableRows.length > 0 && this.selectableRows.every(row => this.selectedRows.includes(row.Id));
    },
    isIndeterminate() {
      const selected = this.selectableRows.filter(row => this.selectedRows.includes(row.Id));
      return selected.length > 0 && selected.length < this.selectableRows.length;
    },
  }
}